import { Response } from 'datx-jsonapi';

import { ResourceType } from '@/enums/ResourceType';
import { Notification } from '@/resources/Notification';
import { AppCollection } from '@/stores/AppStore';

export const FETCH_NOTIFICATIONS_KEY = 'fetch-notifications-key';

export async function fetchNotifications(
  store: AppCollection,
  pageSize: number,
  eventId: string,
  cursorId?: string,
  resourceType?: ResourceType | Array<ResourceType>
): Promise<Response<Notification>> {
  const params = [
    {
      key: 'page[type]',
      value: 'cursor',
    },
    {
      key: 'page[size]',
      value: String(pageSize),
    },
  ];

  if (cursorId) {
    params.push({
      key: 'page[after]',
      value: cursorId,
    });
  }

  return store.fetchAll('notifications', {
    filter: {
      event_id: eventId,
      ...(resourceType && { resource_type: resourceType }),
    },
    include: ['lecture'],
    fields: {
      lectures: ['title', 'slug', 'event_session'],
    },
    params,
  });
}

export async function updateNotification(
  store: AppCollection,
  notificationId: string,
  attributes
): Promise<Response<Notification>> {
  return store.request(`${Notification.type}/${notificationId}`, 'PUT', {
    data: {
      type: Notification.type,
      attributes,
    },
  });
}
